import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { ISearchReply, ISearchRequest } from '../api';

export const fetchAutocomplete = createAsyncAction(
  'FETCH_AUTOCOMPLETE_REQUEST',
  'FETCH_AUTOCOMPLETE_SUCCESS',
  'FETCH_AUTOCOMPLETE_FAILURE',
)<void, string[], Error>();

export const updateQuery = createStandardAction('UPDATE_QUERY')<ISearchRequest>();

export const doSearch = createAsyncAction(
  'DO_SEARCH_REQUEST',
  'DO_SEARCH_SUCCESS',
  'DO_SEARCH_FAILURE',
)<void, ISearchReply, Error>();

interface IMoreResults {
  results: ISearchReply,
  query: ISearchRequest,
}

export const moreResults = createAsyncAction(
  'MORE_RESULTS_REQUEST',
  'MORE_RESULTS_SUCCESS',
  'MORE_RESULTS_FAILURE',
)<void, IMoreResults, Error>();

export const cancelSearch = createStandardAction('CANCEL_SEARCH')();



// WEBPACK FOOTER //
// ./src/actions/searchActions.ts